<template>
  <div class="timeslice-loading">
    <div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div class="pause-icon">
      <img src="../../assets/icon_pause.svg"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TimeSliceLoading',

  }
</script>

<style lang="scss">
  @import "TimeSliceLoading";
</style>
